// extracted by mini-css-extract-plugin
export default {"container":"LoadingSpinner-module_container__JyliL9","sm":"LoadingSpinner-module_sm__KaNWbb","md":"LoadingSpinner-module_md__S8XYgS","lg":"LoadingSpinner-module_lg__vk7IzV"};